import { PlusIcon } from '@heroicons/react/24/outline';

import { Restricted } from 'containers/Restricted';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { EmptyWebhooksIllustration } from '@atoms/illustrations/EmptyWebhooksIllustration';

import {
  WEBHOOKS_EMPTY_CTA_TEST_ID,
  WEBHOOKS_EMPTY_TEST_ID
} from './constants';

import { EMPTY_STATE_MIN_HEIGHT } from '../constants';

type WebhooksEmptyStateProps = {
  onCreate: () => void;
};

export const WebhooksEmptyState = ({ onCreate }: WebhooksEmptyStateProps) => (
  <div
    data-testid={WEBHOOKS_EMPTY_TEST_ID}
    className={`flex ${EMPTY_STATE_MIN_HEIGHT} flex-1 flex-col items-center justify-center gap-6`}
  >
    <EmptyWebhooksIllustration
      data-testid="developers_webhooks_empty_illustration"
      className="size-[99px]"
    />
    <p className="text-lg font-medium leading-[22px] text-content-strong">
      No webhooks configured yet
    </p>
    <Restricted requiredPermission="developers:manage">
      <PrimaryButton
        data-testid={WEBHOOKS_EMPTY_CTA_TEST_ID}
        icon={<PlusIcon className="size-4" />}
        onClick={onCreate}
      >
        Add webhook
      </PrimaryButton>
    </Restricted>
  </div>
);
